export const  currencyFormat = (num)  => {
    if(Number(num) > 1 ) {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

        // return `${num}`
    } else {
return `$${num}`;
    }

}